package com.nonopn.skywatcher.design.utils

import androidx.compose.runtime.Composable
import kotlin.math.min

@Composable
fun rememberColumns(max: Int = 3): Int {
    val columns = when (LocalFrame.current) {
        WindowType.SMARTPHONE_TINY -> min(max, 1)
        WindowType.SMARTPHONE -> min(max, 1)
        WindowType.PHABLET -> min(max, 2)
        WindowType.TABLET -> max
    }

    return columns
}

@Suppress("MagicNumber")
@Composable
fun rememberWideColumns(max: Int = 5): Int {
    val columns = when (LocalFrame.current) {
        WindowType.SMARTPHONE_TINY -> min(max, 1)
        WindowType.SMARTPHONE -> min(max, 1)
        WindowType.PHABLET -> min(max, 3)
        WindowType.TABLET -> min(max, 5)
    }

    return columns
}
